import React, { useState } from 'react';
import './Home.css';
import Notification from './Notification';

function AboutUs() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="home">
      {/* Header */}
      <header className="top-header">
        <div className="header-inner">
          <div className="header-logos">
            <a href="/" aria-label="Go to home page">
              <img src="img/nrb.png" alt="Logo 1" className="header-logo-img" />
            </a>
            <a href="https://ayush.gov.in/" target="_blank" rel="noopener noreferrer" aria-label="Open Ministry of Ayush website">
              <img src="img/MOA.png" alt="Logo 2" className="header-logo-img" />
            </a>
          </div>
          <Notification />
        </div>
      </header>

      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-inner">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/">Home</a></li>
            <li className="nav-dropdown">
              <a href="#about">About</a>
              <ul className="dropdown-menu">
                <li><a href="/about-us">About NRB</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/" target="_blank" rel="noopener noreferrer">About NIN</a></li>
              </ul>
            </li>
            <li><a href="/constitution">Constitution of NRB</a></li>
            <li className="nav-dropdown">
              <a href="#directory">NRB Directory</a>
              <ul className="dropdown-menu">
                <li><a href="/doctors-list">List of Doctors Registered</a></li>
                <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#events">Events</a>
              <ul className="dropdown-menu">
                <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
                <li><a href="/gallery">News & Events</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#resources">Resources</a>
              <ul className="dropdown-menu">
                <li><a href="/state-boards">State Registration Board</a></li>
                <li><a href="/medical-colleges">State Wise Yoga & Naturopathy Medical Colleges in India, 2023</a></li>
                <li><a href="/who-naturopathic-workforce">World Health Organisation (WHO) Region wise listing of countries with Naturopathic Workforce 2023</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#others">Others</a>
              <ul className="dropdown-menu">
                <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/nisargopcharVartaArchive" target="_blank" rel="noopener noreferrer">Nisargopchar Varta</a></li>
              </ul>
            </li>
            <li><a href="/contact">Contact</a></li>
            <li className="nav-cta-mobile"><a href="https://app.nrb.net.in/#/session/signin/step1">Register</a></li>
          </ul>
          <a href="https://app.nrb.net.in/#/session/signin/step1" className="nav-cta">Click here to Register</a>
        </div>
      </nav>

      {/* About NRB Content */}
      <div style={{ 
        minHeight: '60vh', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center',
        padding: '60px 20px',
        background: '#ffffff'
      }}>
        <div style={{
          maxWidth: '900px',
          textAlign: 'center',
          color: '#333'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            marginBottom: '30px',
            color: '#2c3e50'
          }}>About NRB</h1>
          
          <p style={{
            fontSize: '1.1rem',
            lineHeight: '1.8',
            marginBottom: '25px',
            textAlign: 'justify',
            color: '#555'
          }}>
            Naturopathy Registration Board (NRB) is constituted by Ministry of Ayush, Govt. of India is to provide central registration to Naturopathy practitioners, accreditation of Naturopathy institutions and Naturopathy Hospitals is under the aegis of National Institute of Naturopathy, Pune.
          </p>
          
          <p style={{
            fontSize: '1.1rem',
            lineHeight: '1.8',
            textAlign: 'justify',
            color: '#555'
          }}>
            To look after the systems of education and regulation of the Yoga and Naturopathy systems, till National Commission commences its functions by Parliament Act, separate Yoga Certification Board and Naturopathy Registration Board was decided to be constituted by the competent authority. Accordingly, the Yoga Certification Board (YCB) was established and began functioning in 2018 under the aegis of Morarji Desai National Institute of Yoga (MDNIY) with the purpose of achieving certain objectives. Similarly, under the aegis of National Institute of Naturopathy (NIN), the Naturopathy Registration Board (NRB) is constituted with Director, NIN as its CEO and Member Secretary. The NRB will address the issues related to registration of all Naturopathy practitioners, as well as accreditation of Naturopathy institutions and Naturopathy Hospitals.
          </p>
          
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-heading">Naturopathy Registration Board</h3>
            <p className="footer-desc">
              Regulating and promoting excellence in Naturopathy education and practice across India.
            </p>
            <div className="footer-logos">
              <img src="img/nrb.png" alt="NRB Logo" className="footer-logo" />
              <img src="img/MOA.png" alt="Ministry Logo" className="footer-logo" />
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About NRB</a></li>
              <li><a href="/constitution">Constitution of NRB</a></li>
              <li><a href="/doctors-list">List of Doctors Registered</a></li>
              <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Important Links</h4>
            <ul className="footer-links">
              <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
              <li><a href="/gallery">News &amp; Events</a></li>
              <li><a href="/state-boards">State Registration Board</a></li>
              <li><a href="/medical-colleges">Medical Colleges</a></li>
              <li><a href="/who-naturopathic-workforce">WHO Naturopathic Workforce</a></li>
              <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Information</h4>
            <div className="footer-contact">
              <p>Dr Kajal Gupta (Domain Expert), NRB</p>
              <p>📧 nrb@bharatmail.co.in</p>
              <p>📞 86258 33306</p>
              <p>🕐 Mon-Fri: 10:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Naturopathy Registration Board. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms & Conditions</a>
            <span>|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default AboutUs;


